<template>
  <div class="dataSource">
    <div class="title">数据记录<Back type="close"/></div>
    <QA position="dataSource"/>
    <ul class="currentData">
      <li>字段名称：{{ currentRecord.dataName }}</li>
      <li v-if="currentRecord.dataName === '时间'">
        数据内容：{{
          currentRecord.dataValue.split(",").length > 1
            ? currentRecord.dataValue.split(",")[0] +
              "-" +
              currentRecord.dataValue.split(",")[1]
            : currentRecord.dataValue.split(",")[0]
        }}
        <!-- {{
          currentRecord.dataValue.split(",").length > 1
            ? `${currentRecord.dataValue.split(",")[0]}至${
                currentRecord.dataValue.split(",")[1]
              }`
            : `${currentRecord.dataValue.split(",")[0]}至今`
        }} -->
      </li>
      <li v-else>数据内容：{{ currentRecord.dataValue }}</li>
      <li>数据来源：{{ currentRecord.dataSourceName }}</li>
      <li>
        采集时间：{{
          currentRecord.collectionDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
        }}
      </li>
      <li>
        收录时间：{{
          currentRecord.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
        }}
      </li>
    </ul>
    <div class="subTitle">数据更新记录</div>
    <el-timeline>
      <el-timeline-item v-for="(item, index) in list" :key="index">
        <!-- {{ activity.content }} -->
        <ul>
          <li v-if="item.dataName === '时间'">
            更新内容：{{
              item.dataValue.split(",").length > 1
                ? item.dataValue.split(",")[0] +
                  "-" +
                  item.dataValue.split(",")[1]
                : item.dataValue.split(",")[0]
            }}
          </li>
          <li v-else>更新内容：{{ item.dataValue }}</li>
          <li>数据来源：{{ item.dataSourceName }}</li>
          <li>
            采集时间：{{
              item.collectionDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
            }}
          </li>
          <li>
            收录时间：{{
              item.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
            }}
          </li>
        </ul>
      </el-timeline-item>
    </el-timeline>
    <button
      class="btn_edit"
      @click="handleCorrigenda"
      v-if="currentRecord.dataSourceType !== 'CONSUMER'"
    >
      我要勘误
    </button>
  </div>
</template>

<script>
import { dataRecord } from "@/api/user";
import Back from "../../components/Back.vue";
import QA from '../../components/QA.vue';
export default {
  components: { Back, QA },
  data() {
    return {
      records: [
        {
          更新内容: "成都市高新区益州大道886号",
          数据来源: "中国人民大学",
          采集时间: "2022-04-11 14:25"
          // 收录时间: "2022-04-11"
        },
        {
          更新内容: "成都市高新区益州大道886号",
          数据来源: "中国人民大学",
          采集时间: "2022-04-11 14:25"
          // 收录时间: "2022-04-11"
        }
      ],
      id: undefined,
      list: [],
      currentRecord: {}
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getList();
  },
  methods: {
    getList() {
      dataRecord(this.id).then(res => {
        console.log(res);
        this.list = res.data.d;
        this.currentRecord = this.list.filter(item => item.dataTag === "1")[0];
      });
    },
    handleCorrigenda() {
      this.$router.push("corrigendum?id=" + this.id);
      // localStorage.setItem(
      //   "corrigendumInfo",
      //   JSON.stringify(this.currentRecord)
      // );
    }
  }
};
</script>

<style lang="scss" scoped>
.dataSource {
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  ul {
    list-style: none;
  }
  .title {
    display: flex;
    justify-content: space-between;
    color: #393939;
    font-size: 20px;
    font-weight: bold;
    span {
      color: #8d8d8d;
      cursor: pointer;
    }
  }
  .subTitle {
    margin-bottom: 15px;
    font-weight: bold;
  }
  .btn_edit {
    width: 106px;
    height: 41px;
    background: #3a61b1;
    border-radius: 21px;
    border: 0;
    color: #fff;
    margin-top: 23px;
  }
  .currentData {
    padding: 31px 0px 34px 32px;
    background: #f0f2f5;
    list-style: none;
    // margin-top: 28px;
    margin-bottom: 23px;
    font-size: 14px;
    color: #6e6e6e;
    li {
      margin-bottom: 23px;
      &:last-child {
        margin-bottom: 0;
      }
    }

    // .el-timeline-item__content {
    // }
  }
  >>> .el-timeline {
    ul {
      li {
        margin-bottom: 11px;
      }
    }
    .el-timeline-item__tail {
      position: absolute;
      left: 5px;
      top: 15px;
      height: 100%;
      border-left: 1px solid #3a61b1;
    }
    .el-timeline-item__content {
      color: #6e6e6e;
    }
    .el-timeline-item__wrapper {
      position: relative;
      padding-left: 22px;
      top: 7px;
    }
    .el-timeline-item__node {
      background-color: #3a61b1;
    }
    .el-timeline-item__node--normal {
      left: 2px;
      width: 7px;
      height: 7px;
      top: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/DataSource.vue